// Snackbar
export const SNACKBAR_SUCCESS ="SNACKBAR_SUCCESS";
export const SNACKBAR_ERROR = "SNACKBAR_ERROR";
export const SNACKBAR_HIDE = "SNACKBAR_HIDE";